import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=33063673&scoped=true&"
import script from "./Stories.vue?vue&type=script&lang=ts&"
export * from "./Stories.vue?vue&type=script&lang=ts&"
import style0 from "./Stories.vue?vue&type=style&index=0&id=33063673&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33063673",
  null
  
)

export default component.exports